export const getContactEmail = (locale: string) => {
  const defaultMail = 'redakcja@trans.info';

  if (locale === 'de') {
    return 'redaktion@trans.info';
  }

  return defaultMail;
};

export const getSalesContactEmail = (locale: string) => {
  const defaultMail = 'reklama@trans.info';

  if (locale === 'de') {
    return 'werbung@trans.info';
  }

  return defaultMail;
};
